import React from "react";
import Avanish from "../../Assets/img/Group 8150.png";
import Vijay from "../../Assets/img/Group 8151.png";
import Rakesh from "../../Assets/img/Group 8152.png";

import style from "../../Assets/css/b2bFounder.module.css";

const b2bfounders = () => {
	return (
		<>
			<div
				className={`container-fluid justify-content-center  pb-5 pt-5 ${style.section2_J}`}
			>
				<div className={`${style.core_hd_J} my-5`}>
					<h1>Core Team</h1>
				</div>

				<div className="row justify-content-center align-items-center">
					<div
						className={`col-xl-3 col-lg-3 col-md-3 col-sm-5 col-5 mx-2 ${style.core_content_J} `}
					>
						<img src={Avanish} alt="" useMap="#image-map" />
						<map name="image-map">
							<area
								target="_blank"
								alt="Avanish Mundra"
								title="Avanish Mundra"
								href="https://www.linkedin.com/in/avanish-mundhra-6a938848/"
								coords="160,166,211,217"
								shape="rect"
							/>
						</map>
						<div className="my-3">
							<h3>Avanish Mundhra</h3>
							<p>FOUNDER AND CEO</p>
						</div>
					</div>

					<div
						className={`col-xl-3 col-lg-3 col-md-3 col-sm-5 col-5 mx-2 ${style.core_content_J} `}
					>
						<img src={Vijay} alt="" useMap="#image-map-ViJay" />
						<map name="image-map-ViJay">
							<area
								target="_blank"
								alt="Vijay Koushik"
								title="Vijay Koushik"
								href="https://www.linkedin.com/in/vijaykaushikcl/"
								coords="160,166,211,217"
								shape="rect"
							/>
						</map>
						<div className="my-3">
							<h3>Vijay Koushik</h3>
							<p>CO FOUNDER</p>
						</div>
					</div>

					<div
						className={`col-xl-3 col-lg-3 col-md-3 col-sm-5 col-5 mx-2 ${style.core_content_J}`}
					>
						<img src={Rakesh} alt="" useMap="#image-map-Rakesh" />
						<map name="image-map-Rakesh">
							<area
								target="_blank"
								alt="Rakesh Patel"
								title="Rakesh Patel"
								href="https://www.linkedin.com/in/rakeshpatel21/"
								coords="160,166,211,217"
								shape="rect"
							/>
						</map>
						<div className="my-3">
							<h3>Rakesh Patel</h3>
							<p>CO FOUNDER</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default b2bfounders;
